import TownBuyerLandingPage from "./TownBuyerLandingPage";
const HaddonfieldLanding = () => (
  <TownBuyerLandingPage townName="Haddonfield" slug="homes-for-sale-haddonfield" savedLinkId="10353" viewAllUrl="https://homes.prpsj.com/i/homes-for-sale-haddonfield-ac" />
);
export default HaddonfieldLanding;
